/**
 * @generated SignedSource<<1e52561588f0a1f79d84747c10d2031d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LinesOfServiceFragments_LineOfServiceDropdown",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "LineOfService",
  "abstractKey": null
};

node.hash = "4652cb9efe315f6d06ca50706da90560";

export default node;
